<template>
  <div class="content">
    <div class="layout">
      <div class="text-end mb-3">
        <!-- Language Select -->
        <select
          v-model="selectedLang"
          @change="onLangOrCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option
            v-for="lang in languages"
            :key="lang.code"
            :value="lang.code"
          >
            {{ lang.language }}
          </option>
        </select>

        <!-- Country Select -->
        <select
          v-model="selectedCountry"
          @change="onLangOrCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="country in countries"
            :key="country.code"
            :value="country.code"
          >
            {{ country.country }}
          </option>
        </select>
      </div>

      <div class="justify-content-center">
        <div style="width: 100%; max-width: 100%">
          <div
            ref="editor"
            class="ckeditor"
            style="width: 100%; border: 1px solid #ddd; padding: 10px"
          ></div>
        </div>
      </div>

      <div class="text-center my-3">
        <div class="row">
          <div class="col"></div>
          <div class="text-end col">
            <button
              type="button"
              class="btn btn-primary"
              @click="publishContent"
              :disabled="loading"
            >
              <span v-if="loading">Loading...</span>
              <span v-else>Publish Content</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";
// import Quill from "quill";

export default {
  data() {
    return {
      loading: false,
      quill: null,
      content: "",
      selectedLang: "en",
      selectedCountry: "CG",
      languages: [],
      countries: [],
    };
  },
  watch: {
    selectedLang(newLang) {
      this.getContent(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.getContent(this.selectedLang, newCountry);
    },
  },
  async mounted() {
    await this.loadLanguages();
    await this.loadCountries();

    // Set default country if none selected
    if (!this.selectedCountry && this.countries.length > 0) {
      this.selectedCountry = this.countries[0].code;
    }

    // Initialize Quill editor
    this.quill = new Quill(this.$refs.editor, {
      theme: "snow",
      placeholder: "Type here...",
    });

    this.quill.on("text-change", () => {
      this.content = this.quill.root.innerHTML;
    });

    // Fetch initial content with default lang & country
    // this.getContent(this.selectedLang, this.selectedCountry);
  },
  methods: {
    async loadLanguages() {
      try {
        const response = await axios.get("languages", {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        this.handleApiError(error);
      }
    },
    async loadCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getContent(lang, country) {
      if (!lang || !country) return;

      try {
        const response = await axios.get(`/bonus?lang=${lang}&country=${country}`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200) {
          this.quill.root.innerHTML = response.data[0]?.content || "";
          this.content = response.data[0]?.content || "";
        }
      } catch (error) {
        console.error("Error fetching content:", error);
        this.handleApiError(error, true);
      }
    },
    onLangOrCountryChange() {
      // Called when either language or country changes
      this.getContent(this.selectedLang, this.selectedCountry);
    },
    async publishContent() {
      if (!this.content || this.content === "<p><br></p>") {
        this.$notify({
          message: "Please enter some content before publishing",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        this.loading = true;
        const response = await axios.post(
          "/bonus",
          {
            content: this.content,
            language: this.selectedLang,
            country: this.selectedCountry,
          },
          {
            headers: {
              "api-key": Cookies.get("authToken"),
            },
          }
        );

        if (response.status === 201) {
          this.$notify({
            message: "Content published successfully",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        }
      } catch (error) {
        console.error("Error publishing content:", error);
        this.handleApiError(error);
      } finally {
        this.loading = false;
      }
    },
    handleApiError(error, clearContent = false) {
      if (!error.response) {
        console.error("Unknown error:", error);
        return;
      }
      const status = error.response.status;
      if (status === 401) {
        this.$notify({
          message: "Session expired, please login",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        Cookies.remove("authToken");
        this.$router.push("/login");
      } else if (status === 404) {
        if (clearContent) {
          this.quill.root.innerHTML = "";
          this.content = "";
        }
        this.$notify({
          message:
            error.response.data.message || error.response.data.error_message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else {
        this.$notify({
          message:
            error.response.data.message || error.response.data.error_message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
  },
};
</script>

<style scoped>
.ckeditor {
  height: 60vh;
}
</style>
